import {t} from '@/core/utils/t'
import {documentComponent} from '@/core/utils/t/document-component'

export const doc = documentComponent({
  name: 'LoginPage',
  description: 'Basic login page. You might want to consider a custom one that uses LoginForm',
  categories: [],
  props: t.object({
  }),
  examples: {
    basic: {
      props: {
      },
      description: ''
    }
  },
  todo: [],
})
